import React from 'react';

const NotFoundPage: React.FC = () => {
  return <h1 className="title">Page introuvable</h1>;
};

export default NotFoundPage;
